import { Pipe, PipeTransform } from '@angular/core';

/** Destinations longer than this are abbreviated for display. */
const MAX_DISPLAY_LENGTH = 40;
/** Characters kept from the start when abbreviating. */
const HEAD_LENGTH = 16;

/**
 * Abbreviates very long reachability destinations (e.g. ~150-char FCM push
 * tokens) to a readable head + ellipsis. Normal destinations — email
 * addresses, phone numbers — are short and pass through unchanged.
 *
 * Pair with a tooltip bound to the raw value (see `isTruncated`) so the full
 * destination stays accessible on hover.
 */
@Pipe({ name: 'truncateToken', standalone: true })
export class TruncateTokenPipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    if (!value) return '';
    if (value.length <= MAX_DISPLAY_LENGTH) return value;
    return `${value.slice(0, HEAD_LENGTH)}…`;
  }
}

/** Whether the given destination would be abbreviated by {@link TruncateTokenPipe}. */
export function isTruncated(value: string | null | undefined): boolean {
  return !!value && value.length > MAX_DISPLAY_LENGTH;
}
